module.exports = __webpack_public_path__ + "img/new15.a0e17067.png";